export default __webpack_public_path__ + "static/media/footprint-colored.7571cd92.svg";